/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Report_Geography_Select_HintInputs */

const vi_report_geography_select_hint = /** @type {(inputs: Report_Geography_Select_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chọn một tỉnh/thành trong biểu đồ để xem chi tiết đơn hàng.`)
};

/**

* @param {Report_Geography_Select_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const report_geography_select_hint = /** @type {((inputs?: Report_Geography_Select_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Report_Geography_Select_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_report_geography_select_hint(inputs)
});